import { useState, useEffect, useRef } from 'react';
import { isIphone, isSafari } from 'utils/userAgentHelpers';
// Hook
export default function useWindowSize(htmlElementClass = '') {
  const timeoutRef = useRef(null);
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function resize() {
      // Grab an element if class provided
      const [element] = document.getElementsByClassName(htmlElementClass);

      let width = window.innerWidth;
      let height = window.innerHeight;
      if (element) {
        const styles = window.getComputedStyle(element);
        width = styles.getPropertyValue('width');
        height = styles.getPropertyValue('height');
      }
      setWindowSize({
        width: width,
        height: height,
      });
    }

    function handleResize() {
      if (isSafari() && isIphone()) {
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          resize();
        }, 500);
      }
      resize();
    }
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call resize right away so state gets updated with initial window size
    resize();
    // Remove event listener on cleanup
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      window.removeEventListener('resize', handleResize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}
